const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || '').replace(/\/$/, '');

export function resolveResourceUrl(path) {
  if (!path) {
    return '';
  }

  if (/^https?:\/\//i.test(path)) {
    return path;
  }

  if (path.startsWith('/resources/')) {
    return `${API_BASE_URL}${path}`;
  }

  return path;
}
